import { Registration } from '@/modules/workshops-schedule/models/formModels';

export class FormHelper {
    public createEmptyRegistrationForm(eventId: number): Registration {
        const form: Registration = {
            ParticipantData: {
                FirstName: { Value: '', IsVisible: true },
                LastName: { Value: '', IsVisible: true },
                MobileNumber: { Value: '', IsVisible: true },
                Email: { Value: '', IsVisible: true },
                SexTypeId: { Value: 0, IsVisible: true },
                EventId: { Value: eventId, IsVisible: false },
                Country: { Value: '', IsVisible: true },
                City: { Value: '', IsVisible: true },
                ContactMeVia: { Value: '', IsVisible: true },
                Facebook: { Value: '', IsVisible: true },
                Instagram: { Value: '', IsVisible: true },
                Comment: { Value: '', IsVisible: true },
                RecommendedBy: { Value: '', IsVisible: true },
                AdvanceLevelId: { Value: 0, IsVisible: true },
                DietTypeId: { Value: 0, IsVisible: true },
                ArrivalDate: { Value: 0, IsVisible: true },
                DepartureDate: { Value: 0, IsVisible: true },
                HowLongDancing: { Value: 0, IsVisible: true },
                HowMuchDancing: { Value: 0, IsVisible: true },
                TshirtSize: { Value: 0, IsVisible: true },
                SelectedTickets: { Value: [], IsVisible: true },
                EventParticipantGuid: { Value: null, IsVisible: true },
                UpdateData: { Value: false, IsVisible: true },
            },
            DancePartnerData: {
                FirstName: { Value: '', IsVisible: true },
                LastName: { Value: '', IsVisible: true },
                MobileNumber: { Value: '', IsVisible: true },
                Email: { Value: '', IsVisible: true },
                SexTypeId: { Value: 0, IsVisible: true },
                EventId: { Value: eventId, IsVisible: false },
                Country: { Value: '', IsVisible: true },
                City: { Value: '', IsVisible: true },
                ContactMeVia: { Value: '', IsVisible: true },
                Facebook: { Value: '', IsVisible: true },
                Instagram: { Value: '', IsVisible: true },
                Comment: { Value: '', IsVisible: true },
                RecommendedBy: { Value: '', IsVisible: true },
                AdvanceLevelId: { Value: 0, IsVisible: true },
                DietTypeId: { Value: 0, IsVisible: true },
                ArrivalDate: { Value: 0, IsVisible: true },
                DepartureDate: { Value: 0, IsVisible: true },
                HowLongDancing: { Value: 0, IsVisible: true },
                HowMuchDancing: { Value: 0, IsVisible: true },
                TshirtSize: { Value: 0, IsVisible: true },
                SelectedTickets: { Value: [], IsVisible: true },
                EventParticipantGuid: { Value: null, IsVisible: true },
                UpdateData: { Value: false, IsVisible: true },
            },
            IsForCouple: false,
        };

        return form;
    }

    public clearRegistrationForm(form: Registration) {
        form.ParticipantData.FirstName.Value = '';
        form.ParticipantData.LastName.Value = '';
        form.ParticipantData.MobileNumber.Value = '';
        form.ParticipantData.Email.Value = '';
        form.ParticipantData.SexTypeId.Value = null;
        form.ParticipantData.Country.Value = '';
        form.ParticipantData.City.Value = '';
        form.ParticipantData.ContactMeVia.Value = '';
        form.ParticipantData.Facebook.Value = '';
        form.ParticipantData.Instagram.Value = '';
        form.ParticipantData.Comment.Value = '';
        form.ParticipantData.RecommendedBy.Value = '';
        form.ParticipantData.AdvanceLevelId.Value = null;
        form.ParticipantData.DietTypeId.Value = null;
        form.ParticipantData.ArrivalDate.Value = null;
        form.ParticipantData.DepartureDate.Value = null;
        form.ParticipantData.HowLongDancing.Value = null;
        form.ParticipantData.HowMuchDancing.Value = null;
        form.ParticipantData.TshirtSize.Value = null;

        form.DancePartnerData.FirstName.Value = '';
        form.DancePartnerData.LastName.Value = '';
        form.DancePartnerData.MobileNumber.Value = '';
        form.DancePartnerData.Email.Value = '';
        form.DancePartnerData.SexTypeId.Value = null;
        form.DancePartnerData.Country.Value = '';
        form.DancePartnerData.City.Value = '';
        form.DancePartnerData.ContactMeVia.Value = '';
        form.DancePartnerData.Facebook.Value = '';
        form.DancePartnerData.Instagram.Value = '';
        form.DancePartnerData.Comment.Value = '';
        form.DancePartnerData.RecommendedBy.Value = '';
        form.DancePartnerData.AdvanceLevelId.Value = null;
        form.DancePartnerData.DietTypeId.Value = null;
        form.DancePartnerData.ArrivalDate.Value = null;
        form.DancePartnerData.DepartureDate.Value = null;
        form.DancePartnerData.HowLongDancing.Value = null;
        form.DancePartnerData.HowMuchDancing.Value = null;
        form.DancePartnerData.TshirtSize.Value = null;

        form.IsForCouple = false;
    }
}
